<template>
    <div class="block-editor appstore-update-review-status">
        <section>
            <div class="title">Review ID</div>
            <TiptapEditor placeholder="App Store Review ID" :show-attributes="true" v-model="clone.reviewId" automation-mode />
            <small>Durumu güncellenecek yorumun ID'si</small>
        </section>
        <section>
            <div class="title">Durum</div>
            <a-select v-model="clone.status" style="width: 100%">
                <a-select-option value="new">Yeni</a-select-option>
                <a-select-option value="replied">Yanıtlandı</a-select-option>
                <a-select-option value="resolved">Çözüldü</a-select-option>
            </a-select>
            <small>Yorumun yeni durumu</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "AppStoreUpdateReviewStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                reviewId: "",
                status: "new",
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.appstore-update-review-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    small {
        color: #777;
    }
}
</style>
